module.exports = __webpack_public_path__ + "apple-touch-icon-57x57.png?bcd8c3d80381038bebf27d14965de248";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/apple-touch-icon-57x57.png
// module id = 142
// module chunks = 0